import marketModule from '@/store/modules/market.module'

export function getMarketName(marketId) {
  if (!marketId) return ''
  return marketModule.getMarketList().find(market => market.id === marketId)?.name || ''
}

function getMarketIdsUsedInIndexGroup(indexes = [], indexGroupId = null) {
  if (!indexGroupId) return new Set()

  const marketIds = new Set()
  indexes.forEach(index => {
    if (index.index_group_id !== indexGroupId) return
    if (index.market_id) marketIds.add(index.market_id)
  })
  return marketIds
}

export function getAvailableMarketOptionsForIndexGroup(indexes = [], indexGroupId = null) {
  const marketIdsInCurrentGroup = getMarketIdsUsedInIndexGroup(indexes, indexGroupId)
  return marketModule.getMarketList()
    .filter(market => !marketIdsInCurrentGroup.has(market.id))
    .map(market => ({
      value: market.id,
      text: market.name
    }))
}

export function getMissingKnowledgeMarketsForIndexGroup(indexes = [], indexGroupId = null, markets = null) {
  const marketList = Array.isArray(markets) ? markets : marketModule.getMarketList()
  const coveredMarketIds = getMarketIdsUsedInIndexGroup(indexes, indexGroupId)
  return marketList.filter(market => !coveredMarketIds.has(market.id))
}

export function buildMissingKnowledgeMarketsTooltip(missingMarkets = []) {
  if (!missingMarkets.length) return ''

  const missingList = missingMarkets
    .map(market => `• ${market.name}`)
    .join('<br>')

  return 'Each bot market needs a corresponding knowledge market to provide the market specific info to the customer.<br><br>Missing knowledge markets:<br>' + missingList
}

export function getFirstIndexIdForIndexGroup(indexes = [], indexGroupId = null) {
  return indexes.find(index => index.index_group_id === indexGroupId)?.id || null
}

export function buildIndexGroupsById(indexGroups = []) {
  return indexGroups.reduce((acc, group) => {
    if (group?.id) acc[group.id] = group
    return acc
  }, {})
}

export function groupIndexes(indexes = [], indexGroupsById = {}) {
  const groups = []
  const indexesByGroupId = {}

  indexes.forEach(index => {
    const indexGroupId = index.index_group_id
    if (!indexGroupId) return
    if (!indexesByGroupId[indexGroupId]) {
      indexesByGroupId[indexGroupId] = []
    }
    indexesByGroupId[indexGroupId].push(index)
  })

  Object.entries(indexesByGroupId).forEach(([groupId, groupIndexes]) => {
    const indexGroup = indexGroupsById[groupId]
    const markets = groupIndexes
      .map(index => ({
        name: getMarketName(index.market_id) || index.name,
        index,
        marketId: index.market_id
      }))
      .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }))

    groups.push({
      id: groupId,
      indexGroup,
      name: indexGroup?.name || 'Knowledge Base',
      hasIndexGroup: true,
      markets,
      primaryIndex: markets[0]?.index || groupIndexes[0],
      badgeCount: markets.length,
      indexes: groupIndexes
    })
  })

  indexes
    .filter(index => !index.index_group_id)
    .forEach(index => {
      groups.push({
        id: index.id,
        name: index.name,
        hasIndexGroup: false,
        markets: [{ name: index.name, index }],
        primaryIndex: index,
        badgeCount: index.sources?.length || 0
      })
    })

  return groups.sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }))
}
